import { Printer } from "lucide-react";
import MainLayout from "../components/CommonComponents/MainLayout";
import HardwarePrinterSection from "../components/settings/HardwarePrinterSection";

export default function CustomerPrinterSetupPage() {
  return (
    <MainLayout>
      <div className="px-4 py-6 sm:px-6">
        <section className="relative overflow-hidden rounded-[30px] border border-slate-200/85 bg-[linear-gradient(145deg,#fffafa,#fffdfd,#ffffff)] p-5 shadow-[0_24px_80px_rgba(15,23,42,0.08)] sm:p-6">
          <div className="pointer-events-none absolute inset-0">
            <div
              className="absolute -right-10 -top-10 h-40 w-40 rounded-full blur-3xl"
              style={{ background: "color-mix(in srgb, var(--color-primary) 18%, transparent)" }}
            />
          </div>
          <div className="relative">
            <div className="inline-flex items-center gap-2 rounded-full border border-white/70 bg-white/80 px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.22em] text-slate-500 shadow-sm">
              <Printer className="h-3.5 w-3.5" />
              Printer Control
            </div>
            <h1 className="mt-4 text-3xl font-semibold tracking-tight text-slate-950 sm:text-4xl">
              Customer Printer Setup
            </h1>
            <p className="mt-2 max-w-2xl text-sm leading-6 text-slate-500 sm:text-[15px]">
              Configure receipt printer settings per customer, then set branch-specific overrides when needed.
            </p>
          </div>
        </section>

        <section className="mt-5 rounded-[28px] border border-slate-200/85 bg-white py-5 shadow-[0_18px_55px_rgba(15,23,42,0.06)]">
          <HardwarePrinterSection />
        </section>
      </div>
    </MainLayout>
  );
}
